import moment from 'moment';
import React from 'react';
import { TFunction } from 'react-i18next';
import { isNotUndefined } from '../../utils/utils';
import TextInput from './TextInput';

import Text from './Typography';

type Props = {
  onChange: () => void,
  // eslint-disable-next-line
  t: TFunction<string>,
  error: string,
  disabled: boolean
};

export default class DateInputGroup extends React.Component {
  constructor(props: Props) {
    super(props);
    this.formRef = React.createRef(null);
    this.state = {
      month: {
        value: '',
        error: '',
        touched: false
      },
      day: {
        value: '',
        error: '',
        touched: false
      },
      year: {
        value: '',
        error: '',
        touched: false
      },
      touched: false
    };
  }

  validate = (fieldName: string, fieldValue: string) => {
    const rules = {
      month: (value: string) => {
        if (!value || Number(value) > 12 || Number(value) < 1) return ' ';
        return null;
      },
      day: (value: string) => {
        if (!value || Number(value) > 31 || Number(value) < 1) return ' ';
        return null;
      },
      year: (value: string) => {
        if (
          !value ||
          Number(value) < Number(moment().subtract(120, 'years').format('YYYY')) ||
          Number(value) > Number(moment().subtract(18, 'years').format('YYYY'))
        ) return ' ';
        return null;
      }
    };

    const applyRule = rules[fieldName];
    const value = isNotUndefined(fieldValue) ? fieldValue : this.state[fieldName].value;
    if (applyRule) {
      const error = applyRule(value);
      this.setState({
        [fieldName]: { ...this.state[fieldName], error: error }
      });
      return error;
    }
    return null;
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>, { touched = false } = { }) => {
    const fieldName = e.target.name;
    this.setState({ [fieldName]: { ...this.state[fieldName], value: e.target.value, touched } }, () => {
      if (touched) this.validate(fieldName, this.state[fieldName].value);
      this.props.onChange(
        `${this.state.year.value}-${this.state.month.value}-${this.state.day.value}`,
        { touched: this.state.touched }
      );
    });
  }

  componentDidMount() {
    this.formRef.current.addEventListener('focusout', this.handleClickOutside);
  }

  componentWillUnmount() {
    this.formRef.current.removeEventListener('focusout', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.state.touched || this.formRef.current.contains(event.relatedTarget)) return;
    if (this.state.month.touched || this.state.day.touched || this.state.year.touched) {
      this.setState({ touched: true });
      this.props.onChange(
        `${this.state.year.value}-${this.state.month.value}-${this.state.day.value}`,
        { touched: true }
      );
    }
  };

  render() {
    const { t } = this.props;
    const { month, day, year } = this.state;
    return (
      <React.Fragment>
        <Text paragraph color='grey-40'>{t('dob')}</Text>
        <form ref={this.formRef}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '29%', position: 'relative' }}>
              <TextInput
                disabled={this.props.disabled}
                id='month'
                name={'month'}
                value={month.value}
                onChange={this.onChange}
                error={month.error || (this.props.error && !month.value) ? ' ' : ''}
                numeric
                maxLength={2}
                className='narrowed error-hidden date-input'
                noWrapper
              />
              <Text paragraph color='grey-80' align='center'>{t('mm')}</Text>
            </div>
            <div style={{ width: '29%', position: 'relative' }}>
              <TextInput
                disabled={this.props.disabled}
                id='day'
                name={'day'}
                value={day.value}
                onChange={this.onChange}
                error={day.error || (this.props.error && !day.value) ? ' ' : ''}
                numeric
                maxLength={2}
                className='narrowed error-hidden date-input'
                noWrapper
              />
              <Text paragraph color='grey-80' align='center'>{t('dd')}</Text>
            </div>
            <div style={{ width: '32%', position: 'relative' }}>
              <TextInput
                disabled={this.props.disabled}
                id='year'
                name={'year'}
                value={year.value}
                onChange={this.onChange}
                error={year.error || (this.props.error && !year.value) ? ' ' : ''}
                numeric
                maxLength={4}
                className='narrowed error-hidden date-input'
                noWrapper
              />
              <Text paragraph color='grey-80' align='center'>{t('yyyy')}</Text>
            </div>
          </div>
        </form>
        {(this.props.error || this.state.month.error || this.state.day.error || this.state.year.error) && (
          <Text paragraph className='error-text mt-0'>
            {this.props.error || t('validation.invalid_dob')}
          </Text>
        )}
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/shared/DateInputGroup.js